<!-- src\components\MaintainInfo.vue -->
<template>
    <div class="page flex-col">
        <div class="main flex-col">
            <div class="video-section flex-col">
                <!-- 返回按钮 -->
                <div class="btn-back flex-row justify-between" @click="goBack">
                    <img class="img-back" referrerpolicy="no-referrer"
                        src="../assets/img/MasterDDSSlicePNGc10f7b98a802e59b37af721c7a06e583.png" />
                    <span class="text-back">返回</span>
                </div>
                <div class="video-content-container">
                    <!-- 循环遍历文件夹列表 -->
                    <div v-for="(folder, index) in folderList" :key="index">
                        <!-- 文件夹显示部分 -->
                        <div class="btn-video-folder flex-row" @click="showVideoList(folder)"
                            :class="{ 'active': currentFolder === folder }">
                            <img class="img-video-folder" referrerpolicy="no-referrer"
                                src="../assets/img/MasterDDSSlicePNGfa66d558a5bb6c91e978a9d19f4683eb.png" />
                            <span class="text-video-folder">{{ folder }}</span>
                        </div>
                        <!-- 显示当前选中文件夹的视频列表 -->
                        <div v-if="currentFolder === folder" class="btn-video-list flex-col">
                            <!-- 循环遍历当前文件夹的视频列表 -->
                            <a @click="playVideo($event, folder, video.fileName)" href="#"
                                v-for="(video, videoIndex) in filteredVideoList(folder)" :key="videoIndex">
                                <div class="video-item flex-row">
                                    <img class="video-icon" referrerpolicy="no-referrer"
                                        src="../assets/img/MasterDDSSlicePNGd207ce06179eaadb2c03177af659ce7e.png" />
                                    <span class="text-video-list">{{ video.displayName }}</span>
                                    <img class="video-arrow" referrerpolicy="no-referrer"
                                        src="../assets/img/MasterDDSSlicePNG2a9a34bb7000e7ee7b2d69d97e06c029.png" />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- 页面底部信息 -->
                <span class="footer">广西壮族自治区气象培训中心</span>
            </div>
        </div>
    </div>
</template>

<script>
import videoList from '@/assets/videoList.json';

export default {
    data() {
        return {
            videoList: videoList,
            folderList: [],
            currentFolder: null,
            isInIframe: false // 新增一个变量用于标识是否在 iframe 中
        };
    },
    computed: {
        filteredVideoList() {
            return folder => {
                if (this.currentFolder === folder) {
                    return this.videoList.filter(video => video.folder === folder);
                } else {
                    return [];
                }
            };
        }
    },
    methods: {
        playVideo(event, folder, fileName) {
            event.preventDefault();
            this.$router.push({ name: 'VideoPlayer', params: { folder, fileName } });
        },
        goBack() {
            this.$router.go(-1);
        },
        showVideoList(folder) {
            if (this.currentFolder === folder) {
                // 如果当前文件夹已经展开，再次点击则关闭
                this.currentFolder = null;
            } else {
                // 否则，展开点击的文件夹
                this.currentFolder = folder;
            }
        }
    },
    created() {
        this.folderList = [...new Set(this.videoList.map(video => video.folder))];
        this.currentFolder = this.$route.params.folder; // 设置当前文件夹
        // 检查是否在 iframe 中
        if (window !== window.top) {
            this.isInIframe = true; // 如果在 iframe 中，则隐藏返回按钮
        }
    }
};
</script>
<style scoped lang="css" src="../assets/index.rem-MaintainInfo.css" />